"use client"

import Script from "next/script"
import { useEffect, useRef, useState } from "react"
import PolicyConsentModal from "../../ModalLogin/PolicyConsentModal"
import { useRouter } from "next/router"

export default function Footer() {
  const router = useRouter()

  const [showPolicy, setShowPolicy] = useState(false)
  const [initialTab, setInitialTab] = useState(0)

  const containerRef = useRef(null)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (window.VplaySDKWeb) {
      setReady(true)
      return
    }
    const onReady = () => setReady(true)
    window.addEventListener("vplaysdkweb:ready", onReady)
    return () => window.removeEventListener("vplaysdkweb:ready", onReady)
  }, [])

  useEffect(() => {
    if (!ready || !containerRef.current) return
    window.VplaySDKWeb.mountFooter(containerRef.current, {
      platform: "onlivetv",
      locale: "vi",
      onPolicyClick: openPolicyPopup
    })
  }, [ready])

  const openPolicyModal = (tabIndex) => {
    setInitialTab(tabIndex)
    setShowPolicy(true)
  }

  const openPolicyPopup = (key) => {
    // key = terms || privacyPolicy || dataProtection || customerInfoProtection || support || serviceContract
    const policyTabs = {
      terms: 0,
      privacyPolicy: 1,
      dataProtection: 2,
      customerInfoProtection: 3
    }

    if (key in policyTabs) {
      openPolicyModal(policyTabs[key])
      return
    }

    if (key === "support") {
      router.push("/ho-tro")
      return
    }

    if (key === "serviceContract") {
      return
    }
  }

  return (
    <>
      {showPolicy && (
        <PolicyConsentModal
          initialTab={initialTab}
          source="footer"
          onCancel={() => setShowPolicy(false)}
          onConfirm={() => setShowPolicy(false)}
        />
      )}
      <Script src={process.env.NEXT_PUBLIC_CDN_FOOTER} strategy="afterInteractive" />
      <div ref={containerRef} />
    </>
  )
}
